import type { PartnerEnum } from '../groveSchedulerClient'
import type { PartnerSchemaInternal } from './types'

/**
 * Curve Hero partner configuration schema
 * Requires the practice subdomain. Curve Hero does not use OAuth
 * and has no credentials to collect from the customer.
 */
export const curveHeroSchema: PartnerSchemaInternal = {
  partner: 'curve_hero' as PartnerEnum,
  displayName: 'Curve Hero',
  fields: [
    {
      key: 'subdomain',
      label: 'Subdomain',
      type: 'text',
      required: true,
      helperText: 'Curve Hero practice subdomain.',
    },
    {
      key: 'clinic_id',
      label: 'Clinic',
      type: 'remoteSelect',
      required: true,
      source: 'curve_hero.clinics',
      dependsOn: ['subdomain'],
      helperText: 'Clinics are loaded from Curve Hero once a subdomain is set.',
    },
  ],
}
